module.exports = __webpack_public_path__ + "resources/img/img_hacking_testing2_en.d923a13019a3babb26130a013097d59c.png";